import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Cysigil Network Pvt Ltd" />
        <link
          rel="canonical"
          href="https://www.cysigil.com"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-thq-hero-overlay-elm hero-overlay"></div>
        <section className="hero-section">
          <div className="hero-media">
                    <video
          src="/external/homepage_video.mp4"
          loop
          muted
          autoPlay
          playsInline
          className="hero-dfir-video"
        />

          </div>
          <div className="hero-content">
            <div className="hero-content-inner">
              <div className="hero-icon-wrapper">
                <svg
                  width="64"
                  xmlns="http://www.w3.org/2000/svg"
                  height="64"
                  viewBox="0 0 24 24"
                  className="hero-shield-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h1 className="hero-title home-hero-title">
                Enterprise Cybersecurity You Can Trust
              </h1>
              <p className="home-hero-subtitle hero-subtitle">
                Protecting your digital assets with expertized security
                consulting, managed SOC services, and comprehensive VAPT
                solutions.We are ISO certified, compliance-driven,
                results-focused.
              </p>
              <div className="hero-cta-group">
                <a href="#contact">
                  
                    <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                      <span>Talk to an Expert</span>
                    </a>
                  
                </a>
                <a href="#assessment">
                  <a className="btn btn-lg btn-outline" href="/contact-us">
                    <span style={{ color: 'black' }}>Request Assessment</span>
                  </a>
                </a>
              </div>
              <div className="hero-trust-badges">
                {/* <div className="hero-badge-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>ISO Certified</span>
                </div> */}
                {/* <div className="hero-badge-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>SOC Compliant</span>
                </div> */}
                {/* <div className="hero-badge-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>PCI-DSS Ready</span>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="certifications-section">
        <div className="certifications-wrapper">
          <div className="certifications-header">
            <h2 className="section-title">Trusted Industry Standards</h2>
            <p className="section-subtitle">
              Certified and compliant with the world&apos;s leading security
              frameworks
            </p>
          </div>
          <div className="certifications-scroller">
            <div className="certifications-track">
              <div className="certification-card">
                <div className="certification-icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="certification-name">ISO 27001</h3>
                <p className="certification-desc">
                  Information Security Management
                </p>
              </div>
              <div className="certification-card">
                <div className="certification-icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="certification-name">SOC 2 Type II</h3>
                <p className="certification-desc">
                  Service Organization Control
                </p>
              </div>
              <div className="certification-card">
                <div className="certification-icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="certification-name">PCI-DSS</h3>
                <p className="certification-desc">
                  Payment Card Industry Standard
                </p>
              </div>
              <div className="certification-card">
                <div className="certification-icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="certification-name">NIST CSF</h3>
                <p className="certification-desc">Cybersecurity Framework</p>
              </div>
              <div className="certification-card">
                <div className="certification-icon">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="certification-name">HIPAA</h3>
                <p className="certification-desc">Healthcare Data Protection</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-overview-section">
        <div className="services-overview-container">
          <div className="services-overview-header">
            <h2 className="section-title">Comprehensive Security Services</h2>
            <p className="section-subtitle">
              From threat detection to compliance management, we protect what
              matters most
            </p>
          </div>
          <div className="services-overview-grid">
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      rx="2"
                      ry="2"
                      width="20"
                      height="8"
                    ></rect>
                    <rect
                      x="2"
                      y="14"
                      rx="2"
                      ry="2"
                      width="20"
                      height="8"
                    ></rect>
                    <path d="M6 6h.01M6 18h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="service-overview-title">SOC as a Service</h3>
              <p className="service-overview-desc">
                24/7 managed security operations with real-time threat
                detection, incident response, and digital forensics
                capabilities.
              </p>
              <a href="/soc-as-a-service">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="service-overview-title">VAPT Services</h3>
              <p className="service-overview-desc">
                Comprehensive vulnerability assessment and penetration testing
                for web, mobile, API, network, and blockchain applications.
              </p>
              <a href="/web-application-security">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="service-overview-title">Cloud Security</h3>
              <p className="service-overview-desc">
                Cloud risk assessment, CSPM implementation, IAM review, and
                multi-cloud security posture management solutions.
              </p>
              <a href="/cloud-security-assessment">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="service-overview-title">DevSecOps</h3>
              <p className="service-overview-desc">
                Secure SDLC implementation, CI/CD pipeline security, SAST/DAST
                integration, and automated vulnerability scanning.
              </p>
              <a href="/application-security-dev-sec-ops1">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="service-overview-title">Red Team Exercises</h3>
              <p className="service-overview-desc">
                Real-world adversary simulation, purple team collaboration, and
                comprehensive security validation programs.
              </p>
              <a href="/red-team-exercises">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
            <div className="service-overview-card">
              <div className="service-overview-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18\\"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="service-overview-title">OT &amp; IoT Security</h3>
              <p className="service-overview-desc">
                Industrial control systems security, IoT device assessment, and
                operational technology risk management.
              </p>
              <a href="/ot-security">
                <div className="service-overview-link">
                  <span>Learn More</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="expertise-section">
        <div className="expertise-container">
          <div className="expertise-header">
            <h2 className="section-title">Why Choose Cysigil</h2>
            <p className="section-subtitle">
              Proven expertise backed by certifications, experience, and client
              success
            </p>
          </div>
          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">500+</h3>
                <p className="expertise-label">
                  Security Assessments Completed
                </p>
                <p className="expertise-desc">
                  Comprehensive penetration tests and audits across multiple
                  industries and platforms.
                </p>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">15+</h3>
                <p className="expertise-label">Industry Certifications</p>
                <p className="expertise-desc">
                  ISO 27001, CISSP, CEH, OSCP, CISA, CISM  and other globally
                  recognized security credentials.
                </p>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    <rect x="2" y="6" rx="2" width="20" height="14"></rect>
                  </g>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">12 Years</h3>
                <p className="expertise-label">Enterprise Experience</p>
                <p className="expertise-desc">
                  Delivering cybersecurity excellence to leading companies and
                  government agencies.
                </p>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">99.8%</h3>
                <p className="expertise-label">Threat Detection Rate</p>
                <p className="expertise-desc">
                  Industry-leading accuracy in identifying and mitigating
                  security vulnerabilities.
                </p>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      rx="2"
                      ry="2"
                      width="20"
                      height="8"
                    ></rect>
                    <rect
                      x="2"
                      y="14"
                      rx="2"
                      ry="2"
                      width="20"
                      height="8"
                    ></rect>
                    <path d="M6 6h.01M6 18h.01"></path>
                  </g>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">24/7/365</h3>
                <p className="expertise-label">Continuous Monitoring</p>
                <p className="expertise-desc">
                  Round-the-clock SOC operations ensuring your infrastructure is
                  always protected.
                </p>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-icon-wrapper">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="expertise-content">
                <h3 className="expertise-stat">Zero</h3>
                <p className="expertise-label">
                  Client Breaches Post-Engagement
                </p>
                <p className="expertise-desc">
                  Our proven methodologies have kept every client secure after
                  remediation implementation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <h2 className="section-title">Client Success Stories</h2>
            <p className="section-subtitle">
              Trusted by leading enterprises to secure their critical
              infrastructure
            </p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                {' '}
                Cysigil transformed our security posture. Their SOC team
                identified critical vulnerabilities we didn&apos;t know existed
                and helped us achieve SOC 2 compliance in record time.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Moosa</p>
                <p className="testimonial-title">DPO, Exotel Techcom Pvt Ltd </p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                The Red Team exercise revealed gaps in our incident response
                plan we never anticipated. Their approach was professional,
                thorough, and the actionable insights were invaluable.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Manoj Adwani</p>
                <p className="testimonial-title">CEO, Narad.io</p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                Outstanding cloud security assessment. Cysigil identified
                misconfigurations across our multi-cloud environment and
                provided a clear roadmap for remediation. Highly recommended.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Somesh </p>
                <p className="testimonial-title">Director,  O Solutions</p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                Their vCISO service gave us enterprise-level security leadership
                without the enterprise cost. Strategic, knowledgeable, and
                always available when we needed guidance.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Madhu Kumar</p>
                <p className="testimonial-title">VP, Fidelis Technologies</p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                Exceptional DevSecOps integration. They embedded security into
                our CI/CD pipeline without slowing down our release velocity.
                True security automation experts.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Nithin Krishna</p>
                <p className="testimonial-title">
                  Head of Engineering, Deep Cognition
                </p>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="currentColor"
                    stroke="none"
                  ></path>
                </svg>
              </div>
              <p className="testimonial-quote">
                PCI-DSS compliance was a daunting challenge until Cysigil stepped
                in. Their systematic approach made the entire process manageable
                and we passed our audit on the first try.
              </p>
              <div className="testimonial-author">
                <p className="testimonial-name">Manjunath Hirmath</p>
                <p className="testimonial-title">Director, Crinsun </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="casestudies-section">
        <div className="casestudies-wrapper">
          <div className="casestudies-header">
            <h2 className="section-title">Real-World Impact</h2>
            <p className="section-subtitle">
              See how we&apos;ve protected critical infrastructure and prevented
              breaches
            </p>
          </div>
          <div className="casestudies-grid">
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="Financial services security case study"
                  src="https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>Financial Services</span>
                </div>
                <h3 className="casestudy-title">
                  SOC Modernization for Fintech
                </h3>
                <p className="casestudy-desc">
                  Optimized security log ingestion, normalization, and
                  correlation across the SOC, reducing noise by 65% and
                  improving incident detection and response efficiency.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">40%</span>
                    <span className="casestudy-label">Cost reduction </span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">99.9%</span>
                    <span className="casestudy-label">uptime</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="Healthcare cybersecurity case study"
                  src="https://images.pexels.com/photos/17323801/pexels-photo-17323801.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>Healthcare</span>
                </div>
                <h3 className="casestudy-title">
                  Healthcare Provider HIPAA Compliance
                </h3>
                <p className="casestudy-desc">
                  Conducted comprehensive security assessment for a regional
                  healthcare network, identified 142 critical vulnerabilities,
                  and implemented remediation roadmap ensuring full HIPAA and
                  HITRUST compliance within 6 months.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">142</span>
                    <span className="casestudy-label">Issues Resolved</span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">2M+</span>
                    <span className="casestudy-label">Records Protected</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="E-commerce penetration testing case study"
                  src="https://images.pexels.com/photos/5380594/pexels-photo-5380594.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>Telecommunication</span>
                </div>
                <h3 className="casestudy-title">Cloud Telephony Platform</h3>
                <p className="casestudy-desc">
                  security operations implementing 24/7 SOC-as-a-Service with
                  AI-driven threat detection, reducing incident response time by
                  98% and achieving SOC 2 Type II certification.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">78%</span>
                    <span className="casestudy-label">Faster Response</span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">99.9%</span>
                    <span className="casestudy-label">Uptime</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="Manufacturing IoT security case study"
                  src="https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>Manufacturing</span>
                </div>
                <h3 className="casestudy-title">
                  Industrial OT Security Assessment
                </h3>
                <p className="casestudy-desc">
                  Performed advanced OT/ICS security assessment for
                  manufacturing facility with critical infrastructure,
                  identified air-gapped network vulnerabilities, and deployed
                  segmentation strategy preventing potential ransomware attacks.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">35+</span>
                    <span className="casestudy-label">
                      Critical issued fixed
                    </span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">Zero</span>
                    <span className="casestudy-label">Production Impact</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="SaaS cloud security case study"
                  src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>SaaS</span>
                </div>
                <h3 className="casestudy-title">
                  Multi-Cloud Security Posture
                </h3>
                <p className="casestudy-desc">
                  Implemented comprehensive CSPM across AWS, Azure, and GCP for
                  a fast-growing SaaS provider with 100K+ users.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">300+</span>
                    <span className="casestudy-label">
                      Misconfigurations Fixed
                    </span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">80%</span>
                    <span className="casestudy-label">Cost Reduction</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casestudy-card">
              <div className="casestudy-image">
                <img
                  alt="Government red team exercise case study"
                  src="https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="casestudy-content">
                <div className="casestudy-category">
                  <span>B2b</span>
                </div>
                <h3 className="casestudy-title">
                  Critical Infrastructure Red Team
                </h3>
                <p className="casestudy-desc">
                  Advanced persistent threat simulation for a government agency
                  protecting critical national infrastructure assets.
                </p>
                <div className="casestudy-metrics">
                  <div className="casestudy-metric">
                    <span className="casestudy-value">30 Days</span>
                    <span className="casestudy-label">Engagement Duration</span>
                  </div>
                  <div className="casestudy-metric">
                    <span className="casestudy-value">100%</span>
                    <span className="casestudy-label">Gaps Identified</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-expert-section">
        <div className="cta-expert-container">
          <div className="cta-expert-card">
            <div className="cta-expert-icon">
              <svg
                width="64"
                xmlns="http://www.w3.org/2000/svg"
                height="64"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <div className="cta-expert-content">
              <h2 className="section-title">
                Ready to Strengthen Your Security?
              </h2>
              <p className="section-subtitle">
                Connect with our certified security experts for a free
                consultation. We&apos;ll assess your current posture and
                recommend a tailored security strategy.
              </p>
              <div className="cta-expert-features">
                <div className="cta-expert-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Free 30-minute consultation</span>
                </div>
                <div className="cta-expert-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Custom security roadmap</span>
                </div>
                <div className="cta-expert-feature">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>No obligation or pressure</span>
                </div>
              </div>
              <a href="/contact">
                
                  <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                    <span>Talk to an Expert</span>
                  </a>
                
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container3">
        <div className="home-container4">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
* {
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.01ms !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container5">
        <div className="home-container6">
          <Script
            html={`<script defer data-name="certifications-scroller">
(function(){
  const scroller = document.querySelector(".certifications-scroller")
  if (scroller) {
    let isDown = false
    let startX
    let scrollLeft

    scroller.addEventListener("mousedown", (e) => {
      isDown = true
      scroller.style.cursor = "grabbing"
      startX = e.pageX - scroller.offsetLeft
      scrollLeft = scroller.scrollLeft
    })

    scroller.addEventListener("mouseleave", () => {
      isDown = false
      scroller.style.cursor = "grab"
    })

    scroller.addEventListener("mouseup", () => {
      isDown = false
      scroller.style.cursor = "grab"
    })

    scroller.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - scroller.offsetLeft
      const walk = (x - startX) * 2
      scroller.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
